<template>
  <div class="form-group user-select-container" id="user-select-container">
    <div class="tabs-container">
      <ul class="style-nav style2 sub-task-user-nav-new">
        <li
          v-for="tab in usersTabs"
          :key="tab.id"
          :class="{ active: selectedUserTab === tab.alias }"
          @click="
            () => {
              selectedUserTab = tab.alias;
            }
          "
        >
          {{ tab.name.toUpperCase() }}
        </li>
      </ul>
      <div
        :class="
          email.to === '' || email.to === null
            ? 'styleCardContent'
            : 'styleCardContentNoOverFlow'
        "
        class="padding editor-tabs"
      >
        <div class="task-tab">
          <div class="tab-pane active">
            <div class="form-group user-select-container" v-if="!transferMode">
              <div class="task-user-dropdown">
                <ul class="list-group list-group-flush">
                  <input
                    class="form-control search-user-input"
                    type="search"
                    :placeholder="'Assign to main task'"
                    v-model="searchUserNameQuery"
                    v-if="email.to === '' || email.to === null"
                  />
                  <hr />
                  <div class="reply-to-users" v-if="mode == 'reply'">
                    <h5>Reply to</h5>

                    <li
                      v-for="(opt, idx) in taskUsersTalkingUsersArray"
                      :key="idx"
                      class="list-group-item"
                    >
                      <input
                        type="checkbox"
                        class="item-checkbox"
                        :value="opt"
                        v-model="replyUsers"
                        :id="opt.id"
                        @click="testFunction"
                      />
                      <!--                      kobi edit on click-->
                      <!--                      @click="replyUsers = []"-->
                      <!--                        @click="replyUsers=[]"-->

                      <label class="item-text" :for="opt.id">{{
                        opt.full_name | truncate(14)
                      }}</label>
                      <!--            {{ opt.user.role }}-->
                    </li>
                  </div>

                  <!--                  <li-->
                  <!--                    class="list-group-item"-->
                  <!--                    v-if="-->
                  <!--                      email.to === '' || (email.to === null && mode !== 'add')-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    &lt;!&ndash;   <li class="list-group-item" v-if="selectedUserTab === 'MT'"> &ndash;&gt;-->
                  <!--                    <input-->
                  <!--                      type="checkbox"-->
                  <!--                      class="item-checkbox"-->
                  <!--                      id="authUser"-->
                  <!--                      :value="auth.user.id"-->
                  <!--                      v-model="authUserChecked"-->
                  <!--                      @change="buttonOn"-->
                  <!--                    />-->
                  <!--                    <label-->
                  <!--                      class="item-text"-->
                  <!--                      :title="auth.user.first_name"-->
                  <!--                      for="authUser"-->
                  <!--                      >{{-->
                  <!--                        (auth.user.first_name + " " + auth.user.last_name)-->
                  <!--                          | truncate(14)-->
                  <!--                      }}</label-->
                  <!--                    >-->
                  <!--                    <span class="star" @click="changeStarType(auth.user.id)">-->
                  <!--                      <i-->
                  <!--                        :data-star="auth.user.id"-->
                  <!--                        :id="'star-' + auth.user.id"-->
                  <!--                        class=""-->
                  <!--                      ></i>-->
                  <!--                    </span>-->
                  <!--                  </li>-->
                  <div
                    v-if="
                      (!showUsersResults && email.to === '') ||
                        (email.to === null) & (mode == 'add') ||
                        editMode
                    "
                  >
                    <div class="suggest-title-div">Suggestions</div>
                    <li
                      v-for="(opt, idx) in topFive"
                      :key="idx"
                      class="list-group-item"
                      :class="getClassByUserRole(opt.user.role)"
                    >
                      <input
                        type="checkbox"
                        class="item-checkbox"
                        :value="opt.user"
                        v-model="taskUser"
                        :id="opt.user_id"
                      />
                      <label
                        class="item-text"
                        :title="getTitleByUserRole(opt.user.role)"
                        :for="opt.user_id"
                        >{{ opt.user.full_name | truncate(14) }}</label
                      >
                      <!--            {{ opt.user.role }}-->
                      <span class="badge badge-pill badge-info">{{
                        opt.count
                      }}</span>
                      <span class="star" @click="changeStarType(opt.user_id)">
                        <i
                          :data-star="opt.user_id"
                          :id="'star-' + opt.user_id"
                          class=""
                        ></i>
                      </span>
                    </li>
                  </div>
                  <hr />
                  <div v-if="showUsersResults">
                    <li
                      v-for="(opt, idx) in searchUserNameQueryResult"
                      :key="idx"
                      class="list-group-item"
                      :class="getClassByUserRole(opt.role)"
                      v-if="allowedUsersByRole(opt.role)"
                    >
                      <input
                        type="checkbox"
                        class="item-checkbox"
                        v-model="taskUser"
                        :value="opt"
                        :id="opt.id"
                      />
                      <label
                        class="item-text"
                        :title="getTitleByUserRole(opt.role)"
                        :for="opt.id"
                        >{{ opt.full_name | truncate(14) }}</label
                      >
                      <span class="badge badge-pill badge-info">{{
                        opt.countActiveTasks
                      }}</span>
                      <span class="star" @click="changeStarType(opt)">
                        <i
                          :data-star="opt.id"
                          :id="'star-' + opt.id"
                          class=""
                        ></i>
                      </span>
                    </li>
                  </div>

                  <div
                    v-if="
                      (!showUsersResults && email.to === '') ||
                        email.to === null
                    "
                    class="collapse-cont"
                  >
                    <div
                      v-for="(opt, idx) in newSalesPersonList"
                      :key="idx"
                      v-if="opt[0].role !== undefined"
                    >
                      <!--                      // condition for filtering accordions by user role-->
                      <!--                      v-if="-->
                      <!--                      auth.user.role < opt[0].role ||-->
                      <!--                      auth.user.role === opt[0].role-->
                      <!--                      "-->
                      <button
                        class="btn btn-primary collapser"
                        type="button"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        :data-target="'#' + setAccordionId(idx)"
                        v-if="allowedUsersByRole(opt[0].role)"
                      >
                        {{ dictionaries.general.roles[idx].role }}
                      </button>
                      <div
                        class="collapse multi-collapse"
                        :id="setAccordionId(idx)"
                      >
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item">
                            <input
                              type="checkbox"
                              class="item-checkbox"
                              :id="
                                'group-' + dictionaries.general.roles[idx].id
                              "
                              :value="dictionaries.general.roles[idx].id"
                              @click="
                                selectGroup(
                                  dictionaries.general.roles[idx].id,
                                  $event
                                )
                              "
                            />
                            <label
                              class="item-text"
                              :title="dictionaries.general.roles[idx].role"
                              :for="
                                'group-' + dictionaries.general.roles[idx].id
                              "
                              >Select all of group</label
                            >
                            <!--                            <span class="badge badge-pill badge-info">{{-->
                            <!--                              getCountUserActiveTask(user)-->
                            <!--                            }}</span>-->
                            <!--                            <span class="star" @click="changeStarType(user.id)">-->
                            <!--                              <i-->
                            <!--                                      :data-star="user.id"-->
                            <!--                                      :id="'star-' + user.id"-->
                            <!--                                      class=""-->
                            <!--                              ></i>-->
                            <!--                            </span>-->
                          </li>
                        </ul>

                        <ul
                          class="list-group list-group-flush"
                          v-for="user in opt"
                          :key="user"
                        >
                          <li class="list-group-item">
                            <input
                              type="checkbox"
                              class="item-checkbox"
                              v-model="taskUser"
                              :id="user.id"
                              :value="user"
                            />
                            <label
                              class="item-text"
                              :title="user.full_name"
                              :for="user.id"
                              >{{ user.full_name }}</label
                            >
                            <span class="badge badge-pill badge-info">{{
                              getCountUserActiveTask(user)
                            }}</span>
                            <span class="star" @click="changeStarType(user.id)">
                              <i
                                :data-star="user.id"
                                :id="'star-' + user.id"
                                class=""
                              ></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!--                  Email option when creating task-->
                  <div v-if="fromEmailRep ? fromEmailRep : CheckUserPermission([1, 2, 3])">
                  <div
                    class="email-option"
                    style="margin-top: 5px"
                    v-if="
                      canSendEmail() &&
                        task === undefined &&
                        taskUser.length < 1
                    "
                  >
                    <input
                      type="email"
                      class="form-control mb-2 mr-sm-2"
                      id="emailTo"
                      v-model="email.to"
                      placeholder="To"
                      required
                    />
                    <input
                      type="email"
                      class="form-control mb-2 mr-sm-2"
                      id="emailCc"
                      v-model="email.cc"
                      placeholder="Cc"
                    />
                    <input
                      type="email"
                      class="form-control mb-2 mr-sm-2"
                      id="emailBcc"
                      v-model="email.bcc"
                      placeholder="Bcc"
                    />
                  </div>
                  </div>
                </ul>
              </div>
              <div v-if="showPopUp" class="popup-content ">
                <ul class="popup-ul">
                  <li v-for="user in logInfo" :key="user.id" class="popup-li">
                    {{ user.full_name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          class="task-tab"
          v-for="tab in usersTabs"
          v-if="selectedUserTab === tab.alias"
          :key="tab.id"
        >
          <div class="tab-pane active" v-if="tab.alias !== 'MT'">
            <div class="form-group user-select-container" v-if="!transferMode">
              <div class="task-user-dropdown">
                <ul class="list-group list-group-flush">
                  <input
                    class="form-control search-user-input"
                    type="search"
                    :placeholder="'Assign to ' + tab.name"
                    v-model="searchUserNameQuery"
                  />
                  <hr />

                  <li class="list-group-item" v-if="selectedUserTab === 'MT'">
                    <input
                      type="checkbox"
                      class="item-checkbox"
                      :v-model="getVmodelForCheckbox(tab.id)"
                      :value="auth.user"
                      id="currentUser"
                    />
                    <label
                      class=""
                      :title="auth.user.first_name"
                      for="currentUser"
                      >{{ auth.user.first_name | truncate(14) }}</label
                    >
                    <span class="badge badge-pill badge-info">{{
                      activeTasks.length
                    }}</span>
                  </li>
                  <div v-if="!showUsersResults">
                    <div
                      class="suggest-title-div"
                      v-if="mode == 'add' || editMode"
                    >
                      Suggestions
                    </div>
                    <li
                      v-for="(opt, idx) in topFive"
                      :key="idx"
                      class="list-group-item sss"
                      :class="getClassByUserRole(opt.user.role)"
                    >
                      <input
                        type="checkbox"
                        class="item-checkbox"
                        :value="opt.user"
                        v-model="subTasks[tab.id - 2].subTaskUserAssignment"
                        :id="opt.user_id"
                        :checked="checkIfUserAssign(opt.user_id)"
                      />
                      <label
                        class="item-text"
                        :title="getTitleByUserRole(opt.user.role)"
                        :for="opt.user_id"
                        >{{ opt.user.full_name | truncate(14) }}</label
                      >
                      <!--            {{ opt.user.role }}-->
                      <span class="badge badge-pill badge-info">{{
                        opt.count
                      }}</span>
                      <span class="star" @click="changeStarType(opt.user_id)">
                        <i
                          :data-star="opt.user_id"
                          :id="'star-' + opt.user_id"
                          class=""
                        ></i>
                      </span>
                    </li>
                  </div>

                  <!--sub task accordion starts here-->
                  <div
                    v-if="!showUsersResults"
                    id="accordion2"
                    class="collapse-cont"
                  >
                    <div
                      v-for="(opt, idx) in newSalesPersonList"
                      :key="idx"
                      v-if="opt.length > 1"
                    >
                      <button
                        class="btn btn-primary collapser"
                        type="button"
                        data-toggle="collapse"
                        data-parent="#accordion2"
                        :data-target="'#' + setAccordionId(idx)"
                        v-if="allowedUsersByRole(opt[0].role)"
                      >
                        {{ dictionaries.general.roles[idx].role }}
                      </button>
                      <div class="collapse" :id="setAccordionId(idx)">
                        <ul
                          class="list-group list-group-flush"
                          v-for="user in opt"
                          :key="user"
                        >
                          <li class="list-group-item">
                            <input
                              type="checkbox"
                              class="item-checkbox"
                              v-model="
                                subTasks[tab.id - 2].subTaskUserAssignment
                              "
                              :id="user.id"
                              :value="user"
                            />
                            <label
                              class="item-text"
                              :title="user.full_name"
                              :for="user.id"
                              >{{ user.full_name }}</label
                            >
                            <span class="badge badge-pill badge-info">{{
                              getCountUserActiveTask(user)
                            }}</span>
                            <span class="star" @click="changeStarType(user.id)">
                              <i
                                :data-star="user.id"
                                :id="'star-' + user.id"
                                class=""
                              ></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div v-if="showUsersResults">
                    <li
                      v-for="(opt, idx) in searchUserNameQueryResult"
                      :key="idx"
                      class="list-group-item"
                      :class="getClassByUserRole(opt.role)"
                      v-if="allowedUsersByRole(opt.role)"
                    >
                      <input
                        type="checkbox"
                        class="item-checkbox"
                        v-model="taskUser"
                        :value="opt"
                        :id="opt.id"
                      />
                      <label
                        class="item-text"
                        :title="getTitleByUserRole(opt.role)"
                        :for="opt.id"
                        >{{ opt.full_name | truncate(14) }}</label
                      >
                      <span class="badge badge-pill badge-info">{{
                        opt.countActiveTasks
                      }}</span>
                      <span class="star" @click="changeStarType(opt)">
                        <i
                          :data-star="opt.id"
                          :id="'star-' + opt.id"
                          class=""
                        ></i>
                      </span>
                    </li>
                  </div>
                </ul>
              </div>
              <div v-if="showPopUp" class="popup-content ">
                <ul class="popup-ul">
                  <li v-for="user in logInfo" :key="user.id" class="popup-li">
                    {{ user.full_name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--transfer mode-->
      <div class="form-group user-select-container" v-if="false">
        <label>SELECT TRANSFER USER:</label>
        <div class="task-user-dropdown">
          <ul class="list-group list-group-flush">
            <input
              class="form-control"
              placeholder="Transfer to user"
              type="search"
              v-model="searchTransferToUserNameQuery"
            />

            <button
              @click.prevent="setTaskTransfer()"
              class="btn btn-info btn-sm m-b-3px"
              v-if="transferToThisUser.length > 0"
            >
              Transfer to selected
            </button>

            <span class="group-title">Suggestions</span>
            <div v-if="!showTransferToUsersResults">
              <li
                v-for="(opt, idx) in transferToUsersList"
                :key="idx"
                class="list-group-item"
                v-if="allowedUsersByRole(opt.role)"
              >
                <input
                  type="checkbox"
                  class="item-checkbox"
                  v-model="transferToThisUser"
                  :value="opt"
                  :id="opt.id"
                />
                <label class="item-text" :title="opt.full_name" :for="opt.id">{{
                  opt.full_name | truncate(14)
                }}</label>
                <!--              <span class="badge badge-pill badge-info">{{-->
                <!--                opt.countActiveTasks-->
                <!--              }}</span>-->
              </li>
            </div>
            <div v-if="showTransferToUsersResults">
              <li
                v-for="(opt, idx) in searchTransferToUserNameQueryResult"
                :key="idx"
                class="list-group-item"
                v-if="allowedUsersByRole(opt.role)"
              >
                <input
                  type="checkbox"
                  class="item-checkbox"
                  v-model="transferToThisUser"
                  :value="opt"
                  :id="opt.id"
                />
                <label class="item-text" :title="opt.full_name" :for="opt.id">{{
                  opt.full_name | truncate(14)
                }}</label>
                <!--              <span class="badge badge-pill badge-info">{{-->
                <!--                opt.countActiveTasks-->
                <!--              }}</span>-->
              </li>
            </div>

            <span class="group-title">Users</span>
            <div v-if="!showTransferToUsersResults">
              <li
                v-for="(opt, idx) in transferToUsersList"
                :key="idx"
                class="list-group-item"
                v-if="allowedUsersByRole(opt.role)"
              >
                <input
                  type="checkbox"
                  class="item-checkbox"
                  v-model="transferToThisUser"
                  :value="opt"
                  :id="opt.id"
                />
                <label class="item-text" :title="opt.full_name" :for="opt.id">{{
                  opt.full_name | truncate(14)
                }}</label>
                <!--              <span class="badge badge-pill badge-info">{{-->
                <!--                opt.countActiveTasks-->
                <!--              }}</span>-->
              </li>
            </div>
            <div v-if="showTransferToUsersResults">
              <li
                v-for="(opt, idx) in searchTransferToUserNameQueryResult"
                :key="idx"
                class="list-group-item"
                v-if="allowedUsersByRole(opt.role)"
              >
                <input
                  type="checkbox"
                  class="item-checkbox"
                  v-model="transferToThisUser"
                  :value="opt"
                  :id="opt.id"
                />
                <label class="item-text" :title="opt.full_name" :for="opt.id">{{
                  opt.full_name | truncate(14)
                }}</label>
                <!--              <span class="badge badge-pill badge-info">{{-->
                <!--                opt.countActiveTasks-->
                <!--              }}</span>-->
              </li>
            </div>

            <span class="group-title">User Groups</span>
            <li
              v-for="(opt, idx) in dictionaries.general.roles"
              :key="idx"
              class="list-group-item"
              v-if="allowedUsersByRole(opt.role)"
            >
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="taskGroup"
                :value="opt"
                :id="opt.role"
              />
              <label
                class="item-text"
                :title="opt.role_group"
                :for="opt.role"
                >{{ opt.role_group | truncate(14) }}</label
              >
              <span
                class="badge badge-pill badge-group"
                @mouseenter="popUp(opt.activeUsers)"
                @mouseleave="showPopUp = false"
                >{{ opt.activeUsers.length }}</span
              >
            </li>
          </ul>
        </div>
        <div v-if="showPopUp" class="popup-content ">
          <ul class="popup-ul">
            <li v-for="user in logInfo" :key="user.id" class="popup-li">
              {{ user.full_name }}
            </li>
          </ul>
        </div>
      </div>
      <!--      <div v-if="mode=='reply'">Talking users</div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import apiClientCreator from "../../../helpers/api/request";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";
import UsersActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import UsersStatsActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";

export default {
  name: "TaskUsersSelectMainWindow.component",
  mixins: [UsersPermissionCheck, UsersActiveScope, UsersStatsActiveScope],
  props: {
    ifInSaveDelayCondition: {
      type: Boolean
    },
    editMode: {
      type: Boolean
    },
    selectedUserTab: {
      type: String
    },
    transferMode: {
      type: Boolean,
      default() {
        return {};
      }
    },
    task: {
      type: Object
    },

    topFive: {
      type: Array
    },
    countActiveUsersTasks: {
      type: Array
    },
    taskUsersTalkingUsersArray: {
      type: Array
    },

    taskUserStars: {
      type: Array
    },
    usersTabs: {
      type: Array
    },
    subTasks: {
      type: Array
    },
    transferUsers: {
      type: Array
    },
    mode: {
      type: String
    },
    replyUsers: {
      type: Array
    }
  },
  data() {
    return {
      emailOn: false,
      email: {
        to: null,
        cc: null,
        bcc: null,
        subject: ""
      },
      transferStars: [],
      searchUserNameQuery: null,
      taskUser: [],
      primaryTaskUser: 0,
      // taskUser: this.task ? this.taskUsers : [],
      showUsersResults: false,
      searchUserNameQueryResult: [],
      searchTransferToUserNameQuery: null,
      showTransferToUsersResults: false,
      transferToUsersList: null,
      newSalesPersonList: [],
      // placeholderForSearchInput: `Assign Task To${this.selectedUserTab}`,
      searchSalesPersonList: [],
      searchTransferToUserNameQueryResult: [],
      // selectedUserTab:"MT",
      stars: [],
      // subTasks: {
      //   subTask_2:[],
      //   subTask_3:[],
      //   subTask_4:[],
      //   subTask_5:[],
      // },
      starMe: false,
      showPopUp: false,
      logInfo: [],
      taskGroup: [],
      taskReadOnly: [],
      transferModeParent: false,
      transferToThisUser: [],
      authUserChecked: true,
      optOut: false,
      fromEmailRep:false
      // replyToUsers:[],
    };
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading"
    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapGetters("tasks", ["getOpenRepForEmails"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "taskDictionaries",
       "objToEmilOpt",

    ]),
    ...mapGetters("tasks", ["getTasks", "getActiveTasks", "getAllActiveTasks"]),

    newTaskUser() {
      return this.taskUserStars;
    },
    getTransferUsers() {
      return this.transferUsers[0];
    }
  },

  methods: {
    checkIfFromEmailRep(task){
      if(task.reply.length > 0){
        task.reply.map(t=>{
        t.content === "Email Replayed"? this.fromEmailRep = true : '';
        })
      }

    },
    testFunction() {
      if (this.task.task_type.id != 2) {
        this.replyUsers = [];
      }
    },
    selectGroup(groupId, e) {
      if (e.target.checked) {
        let group = this.newSalesPersonList.filter(item => {
          if (item.length > 0) {
            return item[0].role === groupId;
          }
        });
        if (group[0]) {
          group[0].forEach(item => {
            this.taskUser.push(item);
          });
        }
      } else {
        this.taskUser = [];
        this.stars = [];

        // Removes stars
        let stars = document.querySelectorAll(".fa-star");
        stars.forEach(t => {
          t.classList.remove("fas", "far", "fa-star");
        });
      }
    },
    allowedUsersByRole(role) {
      if (
        this.auth.user.role === 1 ||
        this.auth.user.role === 2 ||
        this.auth.user.role === 3 ||
        this.auth.user.role === 4 ||
        this.auth.user.role === 12
      ) {
        return true;
      } else if (this.auth.user.role === 4 || this.auth.user.role === 3) {
        if (role < 8) {
          return true;
        }
      } else if (this.auth.user.role > 4 && this.auth.user.role < 7) {
        if (
          this.auth.user.role === role + 1 ||
          this.auth.user.role === role ||
          (this.auth.user.role === role - 1 && role !== 12)
        ) {
          return true;
        }
      } else if (this.auth.user.role >= 7) {
        if (
          // this.auth.user.role === role + 1 ||
          role > 3 ||
          this.auth.user.role === role
        ) {
          return true;
        }
      }
    },
    getVmodelForCheckbox(id) {
      if (this.task) {
      } else {
        return this.subTasks[id - 2].subTaskUserAssignment;
      }
    },

    canSendEmail() {
      return (
        this.auth.user.role === 1 ||
        this.auth.user.role === 2 ||
        this.auth.user.role === 3 ||
        this.auth.user.role === 4
      );
    },
    buttonOn() {
      this.$root.$emit("give_me_the_button");
    },
    transferAssign() {
      let toRole = this.transferUsers[0][0].role;
      let toId = this.transferUsers[0][0].id;
      //larger then toRole its like user role is 7 and toRole is 1(agent to admin) etc'  but the rank is actually smaller.
      if (this.auth.user.role > toRole) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "YOU CAN NOT TRANSFER TO THIS USER.",
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
      if (this.auth.user.role === toRole || this.auth.user.role < toRole) {
        this.$store.commit("clients/setLoading", true);
        const transferTaskAssign = apiClientCreator(
          `tasks/transfer_task_assign/${this.task.id}`
        );
        transferTaskAssign
          .post("", {
            from: this.auth.user.id,
            transfer_to: toId
          })
          .then(res => {
            this.$emit("closeMainTaskWindow");
          });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task transferred successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.$store.commit("tasks/setFetchTasks", { flag: true });
      }
    },
    setAccordionName(tag) {
      return `collapse-${tag}-${this.selectedUserTab}`;
    },
    setAccordionId(tag) {
      return `collapse-${tag}-${this.selectedUserTab}`;
    },
    generateNewList() {
      let roles = this.dictionaries.general.roles;
      let spl = this.salesPersonList;
      let newSpl = [];
      roles.forEach(t => {
        let a = spl.filter(s => s.role === t.id);
        // let rName = { role_name: t.role };
        // a[0] = { ...a[0], ...rName };
        a[0] = { ...a[0] };
        newSpl.push(a);
      });
      this.newSalesPersonList = newSpl;
    },
    getCountUserActiveTask(user) {
      const tempUser = this.countActiveUsersTasks.find(item => {
        return item.user_id === user.id;
      });
      if (tempUser) {
        return tempUser.count;
      }
    },
    setClassToLastLi() {
      $(".list-item-viki")
        .last()
        .addClass("last");
      $(".list-item-administrator")
        .last()
        .addClass("last");
      $(".list-item-administrator:first").prepend("<h5>Administrator:</h5>");

      $(".list-item-owners")
        .last()
        .addClass("last");
      $(".list-item-owners:first").prepend("<h5>Owners:</h5>");

      $(".list-item-op-manager")
        .last()
        .addClass("last");
      $(".list-item-op-manager:first").prepend("<h5>Op-manager:</h5>");

      $(".list-item-vp-sales")
        .last()
        .addClass("last");
      $(".list-item-vp-sales:first").prepend("<h5>Vp-sales:</h5>");

      $(".list-item-chat-agent")
        .last()
        .addClass("last");
      $(".list-item-chat-agent:first").prepend("<h5>Chat-agent:</h5>");

      $(".list-item-team-leader")
        .last()
        .addClass("last");
      $(".list-item-team-leader:first").prepend("<h5>Team-leader:</h5>");

      $(".list-item-agent")
        .last()
        .addClass("last");

      $(".list-item-agent:first").prepend(
        `<div data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample" style="margin-bottom: 5px">Agents</div>`
      );
      $(".list-item-tech-support")
        .last()
        .addClass("last");
      $(".list-item-tech-support:first").prepend("<h5>Tech-support:</h5>");

      $(".list-item-content-writer")
        .last()
        .addClass("last");
      $(".list-item-content-writer:first").prepend("<h5>Content-writer:</h5>");

      $(".list-item-office-manager")
        .last()
        .addClass("last");
      $(".list-item-office-manager:first").prepend("<h5>Office-manager:</h5>");

      $(".list-item-instructions-manager")
        .last()
        .addClass("last");
      $(".list-item-instructions-manager:first").prepend(
        "<h5>Instructions-manager:</h5>"
      );

      $(".list-item-developer")
        .last()
        .addClass("last");
      $(".list-item-developer:first").prepend("<h5>Developer:</h5>");
    },
    getClassByUserRole(role) {
      let classByRole = "7";
      switch (role) {
        case 0:
          classByRole = "list-item-viki";
          break;
        case 1:
          classByRole = "list-item-administrator";
          break;
        case 2:
          classByRole = "list-item-owners";
          break;
        case 3:
          classByRole = "list-item-op-manager";
          break;
        case 4:
          classByRole = "list-item-vp-sales";
          break;
        case 5:
          classByRole = "list-item-chat-agent";
          break;
        case 6:
          classByRole = "list-item-team-leader";
          break;
        case 7:
          classByRole = "list-item-agent";
          break;
        case 8:
          classByRole = "list-item-tech-support";
          break;
        case 9:
          classByRole = "list-item-content-writer";
          break;
        case 10:
          classByRole = "list-item-office-manager";
          break;
        case 11:
          classByRole = "list-item-instructions-manager";
          break;
        case 12:
          classByRole = "list-item-developer";
          break;
      }
      return classByRole;
      //  return "7"
    },
    getTitleByUserRole(role) {
      let titleByRole = "7";
      switch (role) {
        case 0:
          titleByRole = "Viki";
          break;
        case 1:
          titleByRole = "Administrator";
          break;
        case 2:
          titleByRole = "Owners";
          break;
        case 3:
          titleByRole = "Op-manager";
          break;
        case 4:
          titleByRole = "VP-sales";
          break;
        case 5:
          titleByRole = "Chat-agent";
          break;
        case 6:
          titleByRole = "Team-leader";
          break;
        case 7:
          titleByRole = "Agent";
          break;
        case 8:
          titleByRole = "Tech-support";
          break;
        case 9:
          titleByRole = "Content-writer";
          break;
        case 10:
          titleByRole = "Office-manager";
          break;
        case 11:
          titleByRole = "Instructions-manager";
          break;
        case 12:
          titleByRole = "Developer";
          break;
      }
      return titleByRole;
    },

    checkIfUserAssign(userId) {
      this.taskUser.forEach(user => {
        return user.id === userId;
      });
    },
    // getUsersTaskAssignment(task) {
    //   const creator = this.task.task_assignment.find(
    //     user => user.assigned_by.id === this.auth.user.id
    //   );
    //   const mainUser = task.transfer.find(
    //     user => user.transfer_by.id === this.auth.user.id
    //   );
    //      let ts = this.task.task_sub_task_assignment.foreach()
    //   if (creator !== undefined) {
    //    //  this.taskUser.push(creator);
    //    // // if (mainUser !== undefined) {
    //    //    this.taskUser.push(mainUser);
    //
    //
    //
    //
    //
    //     return true;
    //   //  }
    //   }
    //
    //   if (mainUser !== undefined) {
    //     this.taskUser.push(mainUser);
    //     return true;
    //   }
    //
    //
    //   // let tempTaskUsers = [];
    //   // if (task) {
    //   //   task.task_assignment.forEach(item => {
    //   //     tempTaskUsers.push(item.assigned_to);
    //   //   });
    //   // }
    //   // this.taskUser = tempTaskUsers;
    //
    //
    //   // return tempTaskUsers;
    // },

    getUsersTaskAssignment(task) {
      let tempTaskUsers = [];
      if (task) {
        task.task_assignment.forEach(item => {
          tempTaskUsers.push(item.assigned_to);
        });
      }
      this.taskUser = tempTaskUsers;
      // return tempTaskUsers;
    },
    // countActiveTasksPerUser() {
    //   let tempActiveTasks = this.allActiveTasks.data;
    //   let tempSalesPerson = this.salesPersonList;
    //   if (tempActiveTasks !== undefined && tempSalesPerson !== undefined) {
    //     tempSalesPerson.map(person => {
    //       let personActiveTasks = [];
    //       tempActiveTasks.map(task => {
    //         if (task.user_id === person.id) {
    //           personActiveTasks.push(task);
    //         }
    //       });
    //       person.countActiveTasks = personActiveTasks.length;
    //     });
    //   }
    //   this.salesPersonList = tempSalesPerson;
    // },
    filterFunction(userInput) {
      // return this.searchSalesPersonList.map((p, index) => {
      //           this.searchSalesPersonList[index] = p.filter(user => {
      //             userInput = userInput.trim();
      //             userInput = userInput.toLowerCase();
      //             let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
      //             if (user.hasOwnProperty('full_name')){
      //
      //               return user.full_name.toLowerCase().includes(afterRegex);
      //             }
      //
      //           })
      //
      //         }
      //  );

      return this.salesPersonList.filter(broker => {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return broker.full_name.toLowerCase().includes(afterRegex);
      });
    },
    popUp(activeUsers) {
      if (activeUsers.length > 0) {
        this.showPopUp = true;
      }
      this.logInfo = activeUsers;
    },
    async setTaskTransfer() {
      let apiClient = apiClientCreator(`tasks/transfer_task/${this.task.id}`);
      let transferToIds = [];
      this.transferToThisUser.forEach(user => {
        transferToIds.push(user.id);
      });
      await apiClient
        .post("", { transfer_to: transferToIds })
        .then(res => {
          // this.showReplyTaskText = false;
          this.transferToThisUser = [];
          this.transferTaskTo = false;
          this.searchTransferToUserNameQueryResult = [];
          //   this.$emit("clear_sets"); //TODO: PAY ATTENTION
          //   this.$emit("updated"); //TODO: PAY ATTENTION
          this.$store.commit("tasks/setFetchTasks", { flag: true });
          this.$emit("closeMainTaskWindow");
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Connection Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          this.$store.commit("clients/setLoading", false);
        });
    },
    starShouldBe() {
      let moreThenTwoSelected = this.taskUserStars.length >= 2;
      let oneSelected = this.taskUserStars.length === 1;
      let inSelected = [];

      this.taskUserStars.forEach(user => {
        inSelected.push(user.id);
      });

      if (moreThenTwoSelected) {
        this.setStars(inSelected);
      }
      if (oneSelected) {
        this.ifOne();
      }
    },
    setStars(selectedUsers) {
      //If this is the first selection of users
      if (this.stars.length === 0) {
        //Give first user a full star
        this.firstSelected(selectedUsers[0]);

        //Give other users an empty star
        selectedUsers.slice(1, selectedUsers.length).forEach(star => {
          let elementId = `star-${star}`;
          let a = document.querySelectorAll(`#${elementId}`);
          a.forEach(t => {
            if (!t.classList.contains("fas") || !t.classList.contains("far")) {
              t.classList.add("far", "fa-star");
            }
          });
          // let target = document.getElementById(elementId);
          // target.classList.add("far", "fa-star");
        });
        //Set a stars array to keep track of users selected
        this.stars = selectedUsers;
        let regularStars = document.querySelectorAll(".far");
        let ids = [];
        regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
        this.taskReadOnly = [...new Set(ids)];
      }

      //If after he selected 2 users, and then added more, give them an empty star.
      //   if (this.stars.length < this.newTask.taskUser.length) {//TODO: PAY ATTENTION WAS ON LEV SIDE
      if (this.stars.length < this.taskUserStars.length) {
        selectedUsers.slice(1, selectedUsers.length).forEach(star => {
          let elementId = `star-${star}`;
          let a = document.querySelectorAll(`#${elementId}`);
          a.forEach(t => {
            if (!t.classList.contains("fas") || !t.classList.contains("far")) {
              t.classList.add("far", "fa-star");
            }
          });
        });
        // //Update the stars array to keep track.
        this.stars = selectedUsers;
        let regularStars = document.querySelectorAll(".far");
        let ids = [];
        regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
        this.taskReadOnly = [...new Set(ids)];
      }
      //If he removes selection of users
      // if (this.stars.length > this.newTask.taskUser.length) { TODO: PAY ATTENTION WAS ON LEV SIDE
      if (this.stars.length > this.taskUserStars.length) {
        this.removeStars();
      }
    },
    //The first user selected, give him a full star
    firstSelected(firstId) {
      let f = document.querySelectorAll(`#star-${firstId}`);
      f.forEach(t => {
        t.classList.add("fas", "fa-star");
      });
    },
    setFullStar(id) {
      let elementId = `star-${id}`;
      let target = document.getElementById(elementId);
      target.classList.add("fas", "fa-star");
    },
    setEmptyStar(id) {
      let elementId = `star-${id}`;
      let target = document.getElementById(elementId);
      target.classList.add("far", "fa-star");
    },
    //If only one selection is left, remove stars from everyone.
    ifOne() {
      this.stars.forEach(star => {
        let elementId = `star-${star}`;
        let a = document.querySelectorAll(`#${elementId}`);
        a.forEach(t => {
          t.classList.remove("far", "fas", "fa-star");
        });
      });
      this.stars = [];
      let regularStars = document.querySelectorAll(".far");
      let ids = [];
      regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
      this.taskReadOnly = [...new Set(ids)];
    },

    removeStars() {
      let inSelected = [];
      this.taskUserStars.forEach(t => {
        inSelected.push(t.id);
      });

      let difference = this.stars.filter(id => !inSelected.includes(id));
      difference.forEach(star => {
        let elementId = `star-${star}`;
        let a = document.querySelectorAll(`#${elementId}`);
        a.forEach(t => {
          t.classList.remove("fas", "far", "fa-star");
        });
        // let target = document.getElementById(elementId);
        // target.classList.remove("fas", "far", "fa-star");
      });
      this.stars = inSelected;

      let regularStars = document.querySelectorAll(".far");
      let ids = [];
      regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
      this.taskReadOnly = [...new Set(ids)];
    },
    changeStarType(star) {
      let elementId = `star-${star}`;
      let target = document.getElementById(elementId);
      if (target.classList.contains("far")) {
        target.classList.remove("far", "fa-star");
        target.classList.add("fas", "fa-star");
        let regularStars = document.querySelectorAll(".far");
        let ids = [];
        regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
        this.taskReadOnly = [...new Set(ids)];
        return;
      }
      if (target.classList.contains("fas")) {
        target.classList.remove("fas", "fa-star");
        target.classList.add("far", "fa-star");
        let regularStars = document.querySelectorAll(".far");
        let ids = [];
        regularStars.forEach(el => ids.push(parseInt(el.dataset.star)));
        this.taskReadOnly = [...new Set(ids)];

        return;
      }
    },
    getValueForVModel() {
      return "taskUser";
    }
  },

  watch: {
    "email.to": function() {
      if (this.email.to === "" || this.email.to === null) {
        this.$root.$emit("revertTaskTypeFromEmailToTask");
      } else {
        this.$root.$emit("changeTaskTypeToEmail");

        apiClientCreator(`tasks/checkIfOptOut/${this.email.to}`)
          .post("", {})
          .then(result => {
            if (result.data === 1) {
              this.optOut = true;
              this.$store.commit("main/setShowVikiMsg", {
                show: true,
                msg: "CANNOT SEND TO THIS EMAIL",
                type: "ERROR",
                op: { type: "SYSTEM" }
              });

              this.$store.commit("clients/setLoading", false);
              this.email.to = "";
              this.optOut = false;
            }
            if (result.data === 0) {
              this.optOut = false;
            }
          })
          .catch(err => {});

        this.$emit("taskIsEmail", this.email);
      }
    },

    // 'email.subject': function(){
    //  this.$emit('taskIsEmail', this.email)
    //},
    newTaskUser() {
      this.starShouldBe();
    },

    // getTransferUsers() {
    //   // this.transferAssign();
    // },

    searchUserNameQuery: function() {
      // PREVIOUS
      this.searchUserNameQueryResult = this.filterFunction(
        this.searchUserNameQuery
      );
      if (this.searchUserNameQueryResult.length > 1) {
        this.showUsersResults = true;
      }
      if (this.searchUserNameQuery === "") {
        this.showUsersResults = false;
      }
    },
    // searchUserNameQuery: function() {
    //   if(this.searchSalesPersonList.length === 0){
    //     this.searchSalesPersonList = [...this.newSalesPersonList];
    //   }
    //   if (this.searchUserNameQuery.length > 0) {
    //
    //     this.searchUserNameQueryResult = this.filterFunction(this.searchUserNameQuery);
    //     this.showUsersResults = true;
    //   }else{
    //     this.showUsersResults = false;
    //
    //   }

    //  },

    authUserChecked: function() {
      if (!this.authUserChecked) {
        this.buttonOn();
      }

      if (this.authUserChecked) {
        this.setFullStar(this.auth.user.id);
        this.setFullStar(this.transferStars[0].id);
        let ts = this.transferStars;
        let ef = ts.slice(1);
        ef.forEach(t => {
          this.setEmptyStar(t.id);
        });
      }
    },
    taskUser: function() {
      if (this.taskUser.length > 0) {
        if (this.primaryTaskUser !== this.taskUser[0].id) {
          this.primaryTaskUser = this.taskUser[0].id;
          this.$emit("userRelatedTasks", this.taskUser[0].id);
        }
      }
      if (this.task) {
        this.$emit("changeTaskUser", this.taskUser);

        if (this.editMode) {
          let tempUsers = [];
          // this.taskUser.forEach(item=>{
          //   tempUsers.push(item.assigned_to)
          // })

          this.$emit("changeTaskUser", this.taskUser);
        } else {
          if (this.taskUser.length > this.task.task_assignment.length) {
            this.transferStars.push(this.taskUser[this.taskUser.length - 1]);
          }
          let transferTo = [];
          transferTo.push(this.taskUser[this.taskUser.length - 1]);
          this.transferToThisUser = transferTo;
          if (this.taskUser.length > this.task.task_assignment.length) {
            this.authUserChecked = false;
            this.$emit("usersForTransfer", [
              this.transferToThisUser,
              this.task.id,
              true
            ]);
          }
        }
      } else {
        this.$emit("setTaskUser", {
          user: this.taskUser,
          task: this.selectedUserTab
        });
      }
    },

    replyUsers: function() {
      // this.replyUsers = []
      this.$emit("changeReplyUser", this.replyUsers);
      // this.$root.$emit('user_to_reply_is_selected')
    },
    taskReadOnly: function() {
      this.$emit("getTaskReadOnly", this.taskReadOnly);
    }
  },

  beforeMount() {
    this.transferModeParent = this.transferMode; // save props data to itself's data and deal with it
    // this.getUsersTaskAssignment(this.task);
  },

  mounted() {
  this.email.to =this.getOpenRepForEmails != false && this.getOpenRepForEmails.optout.length > 0  ?  this.getOpenRepForEmails.optout[0].email_from:'';
  if(this.task){
    this.checkIfFromEmailRep(this.task)

    // if(this.taskUsersTalkingUsersArray.length >0){
    //
    //   this.replyToUsers.push(this.taskUsersTalkingUsersArray[0])
    //
    // }
    this.getUsersTaskAssignment(this.task);
  }

    this.transferToUsersList = this.FilterNonActiveUsers();
    /// this.getTopFive(); // PAY ATTENTION -- REMOVED  ON GABI SIDE
    // this.setClassToLastLi();
    // this.taskUser.push(this.$refs.precheck.value)
    this.generateNewList();

    //TODO: REMOVED THIS FOR THE TRANSFER
    // if (this.task) {
    //   $("#user-select-container").addClass("disabledUserSelect");
    // }
    this.$root.$on("emitTransferAss", data => {
      this.transferAssign();
    });
    this.$emit("changeTaskUser", this.taskUser);
  }
};
</script>

<style scoped>
#user-select {
  height: 100%;
}
.user-select-container {
  margin-bottom: 15px;
  /*height: 108%;*/
  /*height: 742px;*/
}

.task-user-dropdown {
  height: 79%;
  /*overflow: auto;*/
  /*border-bottom: 1px solid #dddddd;*/
}
.item-checkbox {
  margin-right: 5px;
  margin-left: -7px;
}
li.list-group-item {
  padding: 0px 0px 0px 13px;
}

.list-group-item > .badge {
  float: right;
  margin-top: 5px;
  margin-right: 5px;
  background-color: #337ab7;
  cursor: pointer;
}
label.item-text {
  font-weight: normal;
}
.popup-content {
  padding: 10px;
  position: absolute;
  top: 450px;
  right: -130px;
  z-index: 10001;
  width: 150px;
  background-color: #fff;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
}
.popup-ul {
  list-style: none;
  padding: 0px;
}
.badge-group {
  background-color: #b7b76a !important;
}
.group-title {
  font-weight: 700;
  padding-left: 50px;
}
.suggest-title-div {
  width: 100%;
  text-align: center;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 2px;
}

.tab-container {
  width: 100% !important;
  margin: 0px;
  padding: 0px;
}
.star {
  margin-left: 0.8rem;
}

/*.list-item-agent, list-item-owners {*/
/*  !*border-bottom: 5px solid #337ab7;*!*/
/*}*/

/*.list-item-agent + .list-item-agent{*/
/*  border-bottom: 5px solid #337ab7;}*/
/*.list-item-owners + .list-item-owners{*/
/*  border-bottom: 5px solid #337ab7;}*/

/*[class~="list-item-agent"]:last-of-type {*/
/*  background: #b5d3ff !important;*/
/*  padding: 2em !important;*/
/*  color: #3f639a !important;*/
/*  font-weight: bold !important;*/
/*}*/
.last {
  margin-bottom: 20px;
  /*border-bottom: 5px grey solid;*/
  /*background-color: red;*/
}
.collapser {
  width: 100%;
  height: 30px;
  margin-bottom: 2px;
}
.list-group {
  margin-bottom: 0;
}
.collapse-cont {
  margin-top: 5px;
}
.disabledUserSelect {
  pointer-events: none;
  opacity: 0.4;
}
.tabs-container {
  height: 99%;
}

.styleCardContent {
  background: white;
  /*min-height: 12rem;*/
  height: 88%;
  /*height: 100%;*/
  border-radius: 5px;
  overflow: auto;
}
.styleCardContentNoOverFlow {
  background: white;
  /*min-height: 12rem;*/
  height: 88%;
  /*height: 100%;*/
  border-radius: 5px;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
                background: white;
              */
}
.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  /*min-width: 172px;*/
  min-width: 15%;
  height: 25px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.padding {
  padding: 1rem;
}

.task-tab {
  width: 100%;
  /*height: 115%;*/
  height: 99%;
}
.sub-task-user-nav {
  flex-wrap: wrap;
  width: 215px;
}
.sub-task-user-nav > li > span {
  font-size: 20px;
  display: none;
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: -1px;
  color: red;
}
.sub-task-user-nav > li:hover > span {
  display: inline-block;
}
.mb-2 {
  margin-bottom: 2px;
}
.sub-task-user-nav-new {
  flex-wrap: wrap;
  width: 258px;
  margin-left: 10px;
}
</style>
